export default {
    feedList(state) {
        for (const index in state.feedList) {
            state.feedList[index] = { 
                ...state.feedList[index], 
                idCopyButtonText: "ID", 
                idCopyIconName: "file_copy",
                mainCatOptions: [], 
                subCatOptions: [], 
                detailCatOptions: []
            }
        }
        
        return state.feedList;
    },
    totalFeedCount(state) {
       
        return state.totalFeedCount ;
    },
    feedTypeListForSelect(state) {
        return state.feedTypeList
          .map((feedType) => ({
            id: feedType.value,
            text: feedType.name,
          }));
      },
    answerTypeList(state) {
        return state.answerTypeList
            .map((answerType) => ({
                id: answerType.value,
                text: answerType.name,
            }));
    },
    
}